export enum TemplateEnum{
    schemax_broadcast = 'Schemax Broadcast Template',
    image_template_new = 'Image Template'
}